import React from "react"
import { Link } from "gatsby"

const CalloutCard = () => {
  return (
    <div className="callout-reg">
      <div className="callout-reg-content">
        <h3 className="callout-reg-text">
        Register Now and Secure Your Spot for the Premier Skeptical Event
        </h3>
        <a href="/registration/" className="btn green-button-outline">
          Register Now!
        </a>
      </div>
    </div>
  )
}
export default CalloutCard